module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/components/docs/styles/Colors/Colors.md
// module id = 243
// module chunks = 0